import { render } from "./MultiUserAutoComplete.vue?vue&type=template&id=0956ef36"
import script from "./MultiUserAutoComplete.vue?vue&type=script&lang=js"
export * from "./MultiUserAutoComplete.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__